"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.replaceAmountTemplate = void 0;
var currencies_1 = require("./currencies");
//{{amount: {"USD": 50, "EUR": 50, "GBP": 50}}},
function replaceAmountTemplate(text, currency) {
    return text.replace(/\{\{amount: (\{.*?\})\}\}/g, function (match, json) {
        var _a;
        try {
            var sanitizedJson = json.replace(/<[^>]*>/g, '');
            var amountByCurrency = JSON.parse(sanitizedJson);
            var currencyToShow = currency;
            if (!(amountByCurrency === null || amountByCurrency === void 0 ? void 0 : amountByCurrency[currency])) {
                currencyToShow = 'EUR';
            }
            var amount = amountByCurrency === null || amountByCurrency === void 0 ? void 0 : amountByCurrency[currencyToShow];
            return amount
                ? "".concat((0, currencies_1.getCurrencySymbol)(currencyToShow), " ").concat((_a = Number(amount)) === null || _a === void 0 ? void 0 : _a.toFixed(2))
                : match;
        }
        catch (err) {
            return match;
        }
    });
}
exports.replaceAmountTemplate = replaceAmountTemplate;
